import { functionNames } from './functions.constants';
import { generateRxToMatchFunctions } from '../regexGenerators';

export const regexToMatchWords = /[a-zA-Z_]/g;
export const regexToMatchSubQueryInstance = /_*\d_*/g;

export const regexToMatchNumbers = /\b\d+(\.\d+)?\b/g;

export const regexToMatchFunctions = generateRxToMatchFunctions(functionNames);

// matches format [thisIsMyString]
export const regexToMatchWordsInsideBrackets = /(?<=\[)\b\w+\b(?=\])/g;

// matches format @thisIsMyString@
export const regexToMatchWordsInsideATSIGN = /(?<=@{1})\b\w+\b(?=@{1})/g;

// matches format [thisIsMyString] with external brackets
export const regexToMatchWordsAndBrackets = /\[(\w+)\]/g;

// matches formula operands
export const regexToMatchOperands = /[\+\-\*\/\%\^]/gm;

// matches subQuery URI
// - used in calcCards & ArgsForm
export const regexToMatchSubQueryUrisWithHashAndAts = /#subQuery@{3}\w+@{3}/g;
export const regexToMatchSubQueryUrisUpToFirstAtDelim = /subQuery@{3}\w+/g;
export const regexToMatchSubQueryUrisWithSlashes = /subQuery\/\w+\//g;

// match variable names in the formula
// - matches subQuery@@@123_456_789_789a@@@Order[age] and Order[age]
// used when saving the calc, to convert to a alias that the BE is ok with
export const formulaVariableNameRegex = /subQuery@{3}\w+@{3}\w+\[\w+\]|\w+\[\w+\]/g;

// matches the subQuery Name used in the formula
export const subQueryNameInFormula = /(\w+)______/g;
